import React from 'react';
import './Home.css'

export default function Footer() {
	return (<div className='footer'>
		<p>
			StarzBuzz
		</p>
	</div>)
}